import { motion } from "framer-motion";
import { Star } from "lucide-react";
import TrackedHeading from "@/components/TrackedHeading";
import { useLang } from "@/lib/site-lang";

const Testimonials = () => {
  const { t } = useLang();
  return (
    <section className="py-28 lg:py-40 border-b border-white/10 bg-[#0D0D0D]" data-testid="testimonials-section">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <p className="mono-label text-[#D35400] mb-5" data-testid="testimonials-kicker">{t.testimonials.kicker}</p>
        <TrackedHeading className="text-5xl md:text-7xl mb-16 lg:mb-24" data-testid="testimonials-heading">
          {t.testimonials.h1} <span className="text-stroke">{t.testimonials.h2}</span>
        </TrackedHeading>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {t.testimonials.quotes.map((q, i) => (
            <motion.blockquote
              key={q.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="bg-[#121212] p-8 lg:p-12 flex flex-col justify-between min-h-[320px]"
              data-testid={`testimonial-${i + 1}`}
            >
              <div>
                <div className="flex items-center justify-between mb-8">
                  <div className="flex gap-1" aria-label="5 star review" data-testid={`testimonial-stars-${i + 1}`}>
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={14} className="fill-[#F39C12] text-[#F39C12]" />
                    ))}
                  </div>
                  <span className="mono-label text-[#52525B]">{t.testimonials.googleLabel}</span>
                </div>
                <p className="font-editorial italic text-xl md:text-2xl text-[#F5F5F5] leading-snug">
                  “{q.text}”
                </p>
              </div>
              <footer className="mt-10">
                <p className="mono-label text-[#F5F5F5]">{q.name}</p>
                <p className="mono-label text-[#52525B] mt-1">{q.meta}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mt-12 text-center"
        >
          <a
            href="https://www.google.com/maps/search/?api=1&query=Local+Moto+4273+Laurentian+Autoroute"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-link"
            className="mono-label inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#E67E22] border border-white/20 hover:border-[#D35400] px-6 py-3 transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D35400]"
          >
            {t.testimonials.reviewsLink} ↗
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
